﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateProfile = void 0;
const gs = require("@ivanlog/gs");
const com = require("../../com/tmpls");
const StatePaged_1 = require("../abstracts/StatePaged");
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const gs_1 = require("@ivanlog/gs");
const models_1 = require("../../api/admin/classes/models");
const AccessTypeEnum_1 = require("../../enums/AccessTypeEnum");
const StateProfiles_1 = require("./StateProfiles");
const gs_com_modal_dialogs_1 = require("@ivanlog/gs-com-modal_dialogs");
class StateProfile extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageProfile, "Profile", true);
        this._userId = 0;
        this._isMyProfile = false;
        this.page.ctrls.btnSave.onclick = () => this.trySave();
        this.page.ctrls.btnDelete.onclick = () => this.tryDelete();
        this.page.ctrls.listAccesses.onItemClicked.addHandler((btn) => {
            this.onChangeAccessHandler(btn.selected, AccessTypeEnum_1.AccessTypeEnum[btn.text]);
        });
        this.page.ctrls.blockAccessControl.hide();
    }
    start(arg) {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (arg) {
                if (arg.id)
                    this._userId = parseInt(arg.id);
                if (arg.myprofile)
                    this._userId = this.app.auth.session.user.id;
            }
            this._isMyProfile = this.app.auth.session.user.id == this._userId;
            const user = yield this.lockgui(this.app.api.admin.profiles.getUser(this._userId));
            if (!user)
                return gs_1.StateRunResultEnum.Failed;
            yield this.fill(user);
            return _super.start.call(this, arg);
        });
    }
    afterStart() {
        const _super = Object.create(null, {
            afterStart: { get: () => super.afterStart }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.afterStart.call(this);
            this.setLabel(this.title + " #" + this._userId);
        });
    }
    trySave() {
        return __awaiter(this, void 0, void 0, function* () {
            var data = yield this.page.ctrls.formUser.getFormData();
            if (!data)
                return;
            data.userId = this._userId;
            const req = new models_1.UpdateUserRequest(data);
            const user = yield this.lockgui(this.app.api.admin.profiles.updateUser(req));
            if (!user)
                return;
            yield this.fill(user);
            new modalCom.DialogOk("Profile changed").show();
        });
    }
    tryDelete() {
        return __awaiter(this, void 0, void 0, function* () {
            const selfDelete = this.app.auth.session.user.id == this._userId;
            const confirm = yield new modalCom.DialogOkNo("Do you want delete this profile and depersonalize all linked information?", "Warning").show();
            if (confirm != gs_com_modal_dialogs_1.ModalDialogResult.Ok)
                return;
            const responce = yield this.lockgui(this.app.api.admin.profiles.deleteUser(this._userId));
            if (!responce)
                return;
            yield new modalCom.DialogOk("Profile deleted. Linked information depersonalized.").show();
            if (selfDelete)
                yield this.app.auth.logout(false);
            else
                yield gs_1.StateGS.Run(StateProfiles_1.StateProfiles);
        });
    }
    fill(user) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.page.ctrls.formUser.fillFormData(user, true);
            if (user.id == this.app.auth.session.user.id)
                this._urlArgs["myprofile"] = "1";
            else
                this._urlArgs["id"] = user.id.toString();
            const data = [];
            for (const auth of user.auths)
                data.push(`${auth.authType}: ${gs.text.clearHtmlToText(auth.data)}`);
            this.page.ctrls.pAuths.html = data.join("<br>");
            if (this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.SuperAdmin)) {
                this.page.ctrls.blockAccessControl.show();
                for (var accessKey in AccessTypeEnum_1.AccessTypeEnum) {
                    const access = parseInt(accessKey);
                    if (accessKey != access.toString())
                        continue;
                    const btn = gs.html.tag("button", { class: "gs-item_btn" }, AccessTypeEnum_1.AccessTypeEnum[access]);
                    if (this.app.auth.userHasAccess(user, access))
                        btn.classList.add('selected');
                    this.page.ctrls.listAccesses.append(btn);
                }
            }
            else if (this._isMyProfile) {
                this.page.ctrls.blockAccessControl.show();
                for (var accessKey in AccessTypeEnum_1.AccessTypeEnum) {
                    const access = parseInt(accessKey);
                    if (accessKey != access.toString())
                        continue;
                    if (!this.app.auth.userHasAccess(user, access))
                        continue;
                    const btn = gs.html.tag("button", { class: "gs-item_btn no-active selected" }, AccessTypeEnum_1.AccessTypeEnum[access]);
                    this.page.ctrls.listAccesses.append(btn);
                }
            }
        });
    }
    onChangeAccessHandler(add, access) {
        return __awaiter(this, void 0, void 0, function* () {
            if (add) {
                const data = new models_1.Access();
                data.type = access.toString();
                data.untilTime = new Date(2000, 1, 1);
                var result = yield this.lockgui(this.app.api.admin.profiles.addUserAccess(this._userId, data));
                if (!result)
                    return;
                yield new modalCom.DialogOk("New access granted for user").show();
            }
            else {
                var result = yield this.lockgui(this.app.api.admin.profiles.removeUserAccess(this._userId, access));
                if (!result)
                    return;
                yield new modalCom.DialogOk("Access closed for user").show();
            }
            if (this._userId == this.app.auth.session.user.id)
                yield this.app.auth.refreshUser();
        });
    }
}
exports.StateProfile = StateProfile;
StateProfile.StateName = "profile";
//# sourceMappingURL=StateProfile.js.map